export default __webpack_public_path__ + "static/media/france.c01e10.svg";